import React, { useCallback, useContext } from 'react'
import { rootStoreContext } from '@app/components/App'
import { observer } from 'mobx-react-lite'

export const TrackSelectPane = observer(() => {
  const rootStore = useContext(rootStoreContext)
  const close = useCallback(() => {
    rootStore.trackSelectOpen = false
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [rootStore.trackSelectOpen])

  return (
    <div
      className="bg-gray-100 fixed left-0 top-0 w-full h-full z-40 flex justify-between"
      onClick={e => {
        if (e.target === e.currentTarget) {
          close()
        }
      }}
    >
      <style>{`body { overflow: hidden }`}</style>
      <div className="lg:max-w-6xl lg:mx-auto bg-white lg:shadow pb-4 lg:my-4 w-full lg:w-128 flex flex-col">
        <div className="flex-shrink-0 text-2xl text-charcoal px-8 pt-8 pb-2 flex justify-between font-semibold">
          <span>Choose a Race</span>
          <span
            className="cursor-pointer hover:text-blue-600 text-xl font-bold self-center"
            onClick={close}
          >
            ✕
          </span>
        </div>
        <div className="overflow-y-auto pl-1">
          {rootStore.tracks.map(track => (
            <div
              key={track.id}
              className="text-lg text-charcoal font-light mt-4 px-8 cursor-pointer hover:text-blue-600"
              onClick={() => {
                rootStore.selectedTrack = track
                close()
              }}
            >
              {track.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})
